import React, { FunctionComponent, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useEffect } from "react";
import { useUsersStyles } from "../useUsersStyles";
import { useStore } from "../../../store";
import { StoreUserList } from "./StoreUserDetails/StoreUserList";
import { UserForm } from "./StoreUserForm";
import { ResetPassword } from "../ResetPassword";
import { Helmet } from "react-helmet-async";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};

export const StoreUsersMaster = () => {
  const classes = useUsersStyles();
  const [users] = useStore("users");
  const [storeUserData] = useState<any>(users);
  const [storeUserFlag, setStoreUserFlag] = useState<boolean>(false);
  const [resetPasswordFlag, setResetPasswordFlag] = useState<boolean>(false);
  const [resetPasswordId, setResetPasswordId] = React.useState<any>();
  const [value, setValue] = React.useState(0);
  const [userId, setUserId] = React.useState<any>();
  const [addStorePermissionFlag, setAddStorePermissionFlag] = useState<boolean>(
    false
  );
  const [editStorePermissionFlag, setEditStorePermissionFlag] = useState<
    boolean
  >(false);
  const [viewStorePermissionFlag, setViewStorePermissionFlag] = useState<
    boolean
  >(false);
  const [user] = useStore("auth", "user");

  useEffect(() => {
    const userStorePermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 7
    );
    if (userStorePermission) {
      if (userStorePermission.is_add === false) {
        setAddStorePermissionFlag(true);
      }
      if (userStorePermission.is_edit === false) {
        setEditStorePermissionFlag(true);
      }
      if (userStorePermission.is_view === false) {
        setViewStorePermissionFlag(true);
        setUserId("");
        setValue(1);
      }
      if (
        userStorePermission.is_add === true &&
        userStorePermission.is_edit === true &&
        userStorePermission.is_view === true
      ) {
        setAddStorePermissionFlag(false);
        setViewStorePermissionFlag(false);
        setEditStorePermissionFlag(false);
      }
    }
  }, [user.permissions]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setUserId("");
    setStoreUserFlag(false);
    setResetPasswordFlag(false);
  };

  const goBackToList = () => {
    setValue(0);
    setStoreUserFlag(false);
    setUserId("");
    setResetPasswordFlag(false);
  };

  const goToEdit = (id: number) => {
    setUserId(id);
    setValue(1);
    setStoreUserFlag(true);
  };

  const handleResetPassword = (id: number) => {
    setResetPasswordId(id);
    setResetPasswordFlag(true);
    setValue(2);
  };

  const goBack = () => {
    setResetPasswordId("");
    setResetPasswordFlag(false);
    setValue(0);
  };

  return (
    <>
      <Helmet>
        <title>Store users</title>
      </Helmet>
      <div className={classes.root}>
        <Grid
          container
          spacing={2}
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item xs={12}>
            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
              >
                <Tab
                  style={{ display: viewStorePermissionFlag ? "none" : "" }}
                  label={"Store Users List"}
                />
                {storeUserFlag ? (
                  <Tab
                    // style={{ display: addStorePermissionFlag ? "none" : "" }}
                    label={"Edit Store  User"}
                    disabled
                  />
                ) : (
                  <Tab
                    style={{
                      display: addStorePermissionFlag === true ? "none" : "",
                    }}
                    label={"Create Store User"}
                  />
                )}
                {resetPasswordFlag === true ? (
                  <Tab label="Reset Password" disabled />
                ) : null}
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <StoreUserList
                storeList={"store"}
                goToEdit={goToEdit}
                handleResetPassword={handleResetPassword}
                editStorePermissionFlag={editStorePermissionFlag}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <UserForm
                userId={userId !== "" ? userId : "new"}
                goBackToList={goBackToList}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <ResetPassword
                resetPasswordId={resetPasswordId}
                storeList={"store"}
                goBackToList={goBackToList}
                goBack={goBack}
                storeUserData={storeUserData}
                posUserData={[]}
              />
            </TabPanel>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
